<template>
<div v-if="Object.keys(productAttributes).length > 0" 

:class="[
    'variations-wrapper',
    { 'is-choosing': isChoosed }
]"

>
  <template v-for="(attributeGroup, groupKey) in productAttributes" :key="groupKey">
    <div 
      v-if="groupKey !== 'number-of-namenecklace'"
      :data-key="groupKey"
      :class="[
        'variations',
        'variations--customise',
        {
          'active': activeAttributeGroup === String(groupKey),
          'nameneck-hidden': nameNecklace.status === 'yes' && matchesHiddenAttribute(nameNecklace.idHide, String(groupKey)),
          'nameneck-font-visual': props.customiseFontVisualNameNecklace && props.customiseFontVisualNameNecklace?.status === 'yes'
        }
      ]"
      >
  
      <div class="atribute-heading" @click="toggleAttributeGroup(groupKey)">
        <div class="label" :data-key="groupKey" >
          <span v-if="attributeGroup.description && Object.keys(attributeGroup.description).length > 0" class="infor-att"
            :data-key="groupKey" @click.stop="showAttributesDescription(String(groupKey))">
            {{ attributeGroup.name }}
            <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="info-icon">
              <rect width="12" height="12" fill="rgba(157, 157, 157, 0.1)" />
              <circle cx="8" cy="8" r="6.5" fill="white" stroke="black" />
              <path
                d="M8 4C7.44772 4 7 4.44772 7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4Z"
                fill="black" />
              <rect x="7.25" y="7" width="1.5" height="4.5" fill="black" />
            </svg>
          </span>
          <div v-else-if="props.checkPixiu && attributeGroup.type == 'gemstone'" class="custom_size_guide">
            <span>{{ attributeGroup.name }}</span>
            <Meaning/>
          </div>
          <span v-else>
            {{ attributeGroup.name }}
          </span>
          <AttributeDescription 
          v-if="attributeGroup.gemstone_items && Object.keys(attributeGroup?.description || {}).length > 0"
          :nameAttribute="attributeGroup?.name" 
          :data="attributeGroup?.description"
          :attributes="attributeGroup.gemstone_items ? attributeGroup?.gemstone_items : attributeGroup?.items"
          :dataKey="groupKey" />
        </div>
        <div class="atribute-heading__right">
          <span class="attribute_selected_name" :data-attribute-key="attributeGroup.name"> {{ getSelectedAttributeName(String(groupKey)) }}</span>
          <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.8987 14.7678L11.5 10.3786L7.10125 14.7678L5.75 13.4165L11.5 7.6665L17.25 13.4165L15.8987 14.7678Z"
              fill="#212529"></path>
          </svg>
        </div>
        

      </div>
      <div :class="[
        'attributes-main',
  { 'attribute-main--gemstone': attributeGroup.items && Object.keys(attributeGroup.items).length > 0 }
      ]">

        <template v-if="attributeGroup.items && Object.keys(attributeGroup.items).length > 0">
          <ul :class="[
                'jos_variation',
                'var-' + groupKey,
                { 'var-length-name': matchesHiddenAttribute(nameNecklace.idHide, String(groupKey))  },
                { 'show-only-img': attributeGroup?.show_only_img === 'yes' }
              ]"
            :data-att="groupKey"
            >
            <li v-for="(attribute, index) in Object.values(attributeGroup.items)" :key="attribute.id" :id="attribute.id"
              :data-key="attribute.value" 
               :class="[
                  'item_exits',
                  {
                    selected: isSelected(attribute.id.toString(), String(groupKey)),
                    notselected: !isSelected(attribute.id.toString(), String(groupKey))
                  }
                ]"
               @click="onOptionClickCustomise(attribute.id.toString(), String(groupKey), attributeGroup.name)">
              <span class="thumb-attr" v-if="attribute.thumb"><img :src="`${baseUrl}api/wp-content/uploads/${attribute.thumb}`" alt=""></span>
              <span class="name-attr" >{{ attribute.name }}</span>
            </li>
          </ul>

          <!-- Initials Dropdowns -->
          <div v-if="groupKey === 'initials' && initialsCount > 0" class="initials-dropdowns-wrapper">
            <div v-for="index in initialsCount" :key="index" class="initial-dropdown-item">
              <p :for="`initial-select-${index}`" class="initial-label">
                {{ getInitialLabel(index) }}:
              </p>
              <div :class="['initial-select-wrapper', { 'is_show': showInitialsDropdown[index] }]" @click.stop>
                <div class="initial-select-display" @click.stop="toggleInitialsDropdown(index)">
                  {{ initialsValues[index] || 'Select letter' }}
                  <svg 
                    width="12" 
                    height="8" 
                    viewBox="0 0 12 8" 
                    fill="none" 
                    xmlns="http://www.w3.org/2000/svg"
                    :class="{ 'dropdown-arrow-open': showInitialsDropdown[index] }"
                    class="dropdown-arrow"
                  >
                    <path d="M1 1L6 6L11 1" :stroke="showInitialsDropdown[index] ? '#ffb3c0' : '#333'" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                </div>
                <div v-if="showInitialsDropdown[index]" class="initial-dropdown-menu">
                  <div 
                    v-for="letter in alphabetList" 
                    :key="letter"
                    :class="['initial-dropdown-item-option', { active: initialsValues[index] === letter }]"
                    @click.stop="selectInitialLetter(index, letter)"
                  >
                    {{ letter }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
       <template v-if="attributeGroup.gemstone_items && Object.keys(attributeGroup.gemstone_items).length > 0">
          <div class="gemstone-choose" v-if="hasNoStone === 'yes'">
            <span :class="[
              'gemstone-choose__item gemstone-choose__item--yes',
              { active: chooseGemstone === 'yes' }
            ]" data-value="yes" @click="chooseNoneStone('yes')">
              Yes
            </span>

            <span :class="[
              'gemstone-choose__item gemstone-choose__item--no',
              { active: chooseGemstone === 'no' }
            ]" data-value="no" @click="chooseNoneStone('no')">
              No
            </span>
          </div>
          <div class="gemstone-wrapper pt_meaning_guide">
            <Meaning v-if="props.checkPixiu" />
            <div v-for="(gemstoneAttr, gemstoneKey) in attributeGroup.gemstone_items" :key="gemstoneKey"
              :data-key="gemstoneKey" :class="[
                'gemstone-item',
                'gemstone-item-box',
                {
                  active: activeGemstones[groupKey] === gemstoneKey,
                  gemstone_none: isGemstoneNone(gemstoneAttr)
                }
              ]">
              <div class="gemstone-item__heading" @click="toggleGemstoneVariations(gemstoneKey,groupKey)">
                <span class="label-gemstone">{{ gemstoneAttr[0]?.name_attr }}</span>
                <div class="gemstone-item-right">
                  <span class="gemstone-display-grid" :class="{ active: isGridView[gemstoneKey] !== false }" :data-gemstone-key="gemstoneKey" @click.stop="displayGrid(gemstoneKey)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                      <path
                        d="M4 11h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm10 0h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zM4 21h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm10 0h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1z"
                        fill="#212529" />
                    </svg>

                  </span>
                  <span class="gemstone-display-list" :class="{ active: isGridView[gemstoneKey] === false }" :data-gemstone-key="gemstoneKey" @click.stop="displayList(gemstoneKey)">
                    <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M4 2.16667H15.2C15.68 2.16667 16 1.83333 16 1.33333C16 0.833333 15.68 0.5 15.2 0.5H4C3.52 0.5 3.2 0.833333 3.2 1.33333C3.2 1.83333 3.52 2.16667 4 2.16667ZM15.2 4.66667H7.2C6.72 4.66667 6.4 5 6.4 5.5C6.4 6 6.72 6.33333 7.2 6.33333H15.2C15.68 6.33333 16 6 16 5.5C16 5 15.68 4.66667 15.2 4.66667ZM15.2 8.83333H10.4C9.92 8.83333 9.6 9.16667 9.6 9.66667C9.6 10.1667 9.92 10.5 10.4 10.5H15.2C15.68 10.5 16 10.1667 16 9.66667C16 9.16667 15.68 8.83333 15.2 8.83333ZM0.8 0.5C0.32 0.5 0 0.833333 0 1.33333C0 1.83333 0.32 2.16667 0.8 2.16667C1.28 2.16667 1.6 1.83333 1.6 1.33333C1.6 0.833333 1.28 0.5 0.8 0.5ZM4 4.66667C3.52 4.66667 3.2 5 3.2 5.5C3.2 6 3.52 6.33333 4 6.33333C4.48 6.33333 4.8 6 4.8 5.5C4.8 5 4.48 4.66667 4 4.66667ZM7.2 8.83333C6.72 8.83333 6.4 9.16667 6.4 9.66667C6.4 10.1667 6.72 10.5 7.2 10.5C7.68 10.5 8 10.1667 8 9.66667C8 9.16667 7.68 8.83333 7.2 8.83333Z"
                        fill="#212529" />
                    </svg>

                  </span>
                  <div class="gemstone-item__expan-close"><svg width="23" height="23" viewBox="0 0 23 23" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.8987 14.7678L11.5 10.3786L7.10125 14.7678L5.75 13.4165L11.5 7.6665L17.25 13.4165L15.8987 14.7678Z"
                        fill="#212529"></path>
                    </svg></div>
                </div>

              </div>

              <div v-if="isSplideEnabled && isGridView[gemstoneKey] !== false" class="splide-wrapper">
                <Splide :options="splideOptions" :class="['jos_variation gemstone-variations', 'var-' + groupKey]"
                  :data-att="groupKey">
                  <SplideSlide v-for="attribute in gemstoneAttr" :key="attribute.id">
                    <div :id="attribute.id" :data-key="attribute.value"
                      :class="['item_exits', { selected: isSelected(attribute.id.toString(), String(groupKey)) }]"
                      @click="onOptionClickCustomise(attribute.id.toString(), String(groupKey))">
                      <img v-if="attribute.thumb" :src="`${baseUrl}api/wp-content/uploads/${attribute.thumb}`" alt="">
                      {{ attribute.name }}
                    </div>
                  </SplideSlide>
                </Splide>
              </div>

              <ul v-else :class="['jos_variation gemstone-variations', 'var-' + groupKey]" :data-att="groupKey">
                <li v-for="attribute in gemstoneAttr" :key="attribute.id" :id="attribute.id" :data-key="attribute.value"
                  :class="['item_exits', {
                    selected: isSelected(attribute.id.toString(), String(groupKey))
                  }]" 
                  @click="onOptionClickCustomise(attribute.id.toString(), String(groupKey), attributeGroup.name)">
                  <img v-if="attribute.thumb" :src="`${baseUrl}api/wp-content/uploads/${attribute.thumb}`" alt="">
                  {{ attribute.name }}
                </li>
              </ul>

            </div>
          </div>
        </template>
      </div>

      <template v-if="groupKey === Object.keys(productAttributes).slice(-1)[0] && isCloseButtonVisible"
        @click="resetSelections">
        <a class="reset_variations" style="visibility: visible;"><span class="close">+</span></a>
      </template>
    <div 
    v-if="nameNecklace.status === 'yes' && nameNecklace.afterAttribute === groupKey"
    :class="[
    'namenecklace-form-wrapper',
    'attributes-main',
    {
      activePreview: activePreview === 'yes',
      dropdown_open: showCustomSelect === true,
    }
  ]"
    @click.stop
    >
    <template
    v-if="nameCharmSelect && nameCharmSelect.options.length > 0"
    >

    <!--  Multi Namenecklace -->
   
      <!-- Select Number of Name Charms -->
      <div class="custom_form_select" @click.stop>
        <label>{{ nameCharmSelect.label }}</label>
        <div class="select-wrapper">
          <!-- Hidden select for form submission -->
          <select 
            :value="currentCharmCount"
            style="display: none;"
          >
            <option v-for="option in nameCharmSelect.options" :key="option.value" :value="option.value">
              {{ option.label }}
            </option>
          </select>

          <!-- Custom select display -->
          <div class="select-display" @click.stop="toggleCustomDropdown">
            {{ selectedNameCharmOption?.label || '' }}
            <svg 
              width="12" 
              height="8" 
              viewBox="0 0 12 8" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              :class="{ 'dropdown-arrow-open': showCustomSelect }"
              class="dropdown-arrow"
            >
              <path d="M1 1L6 6L11 1" stroke="#333" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>

          <!-- Custom dropdown list -->
          <div v-if="showCustomSelect" class="custom-dropdown" @click.stop>
            <div 
              v-for="option in nameCharmSelect.options" 
              :key="option.value"
              :class="['dropdown-item', { active: currentCharmCount === option.value }]"
              @click.stop="selectCharmOption(option.value,option.att_id)"
            >
             
              <span class="option-label">{{ option.label }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Render Name Charm Forms -->
      <div v-for="charmIndex in currentCharmCount" :key="charmIndex" class="name-charm-wrapper" @click.stop>
        <div class="charm-form-header">
          <h4>{{ getNameCharmTitle(charmIndex) }}</h4>
        </div>
        <NameNecklaceForm
          :id="`namenecklace-main-${charmIndex}`"
          :index="charmIndex"
          :maxlength="nameNecklace.maxlength"
          :symbols="nameNecklace.symbol"
          :fontVisual="customiseFontVisualNameNecklace?.status"
          :fontSelected="fontSelected"
          :colorSelected="colorSelected"
          :placeholderText="'Enter your first name '"
          :nameinput="`namenecklace-input-${charmIndex}`"
          :valueinput="activeMultiNameValue[charmIndex] || ''"
          :productID="props.productId"
          @input-name="syncMultiName"
          @update-name="updateMultiName"
        />

        <!-- Back Engraving Form for each charm -->
        <div 
          v-if="props.customiseBackNameNecklace.status === 'yes' && props.isEngraving"
          :class="['namenecklace-form','back-namenecklace-form']"
          @click.stop
        >
          <div class="back-engraving-header">
            <h5>{{ charmIndex }}<span v-if="charmIndex === 1">st</span><span v-else-if="charmIndex === 2">nd</span><span v-else-if="charmIndex === 3">rd</span><span v-else>th</span> inscription (up to 9 characters):</h5>
          </div>
          <NameNecklaceForm
            :id="`namenecklace-back-${charmIndex}`"
            :maxlength="customiseBackNameNecklace.maxlength"
            :symbols="customiseBackNameNecklace.symbol"
            :placeholderText="`Enter back engraving (Charm ${charmIndex})`"
            :nameinput="`back-namenecklace-input-${charmIndex}`"
            :productID="props.productId"
            :fontSelected="fontSelected"
          />
        </div>
      </div>
       </template>

       <!-- single name necklace -->
       <template
       v-else
       >
       <NameNecklaceForm
      id="namenecklace-main"
      :maxlength="customiseNameNecklace.maxlength"
      :symbols="customiseNameNecklace.symbol"
      :fontVisual="customiseFontVisualNameNecklace?.status"
      :fontSelected = "fontSelected"
      :colorSelected = "colorSelected"
      placeholderText="Enter your first name"
      nameinput="namenecklace-input"
      :productID="props.productId"
      :isChina = "props.checkChina"
       />
       <div
          v-if="props.customiseBackNameNecklace.status === 'yes'"
          :class="[
            'namenecklace-form',
            'back-namenecklace-form'
          ]"
          @click.stop
        >

     <NameNecklaceForm
     id="namenecklace-back"
    :maxlength="customiseBackNameNecklace.maxlength"
    :symbols="customiseBackNameNecklace.symbol"
    placeholderText="Enter side engraving"
    nameinput="back-namenecklace-input"
    :productID="props.productId"
    :isChina="props.checkChina"
    :fontSelected = "fontSelected"
     />
     </div>
       </template> 
    </div>
    </div>
  </template>
     <input type="hidden" name="add-to-cart" :value="productId" />
      <input type="hidden" name="product_id" :value="productId" />
      <input type="hidden" name="ids" id="ids" :value="ids">
     <input
      type="hidden"
      id="initialsValues"
      name="initialsValues"
      :value="JSON.stringify(initialsValues)"
    >

    
      <input
        v-if="
          multiNameValue &&
          Object.values(multiNameValue).some(value => value?.length > 0)
        "
        type="hidden"
        id="multiNameValue"
        name="multiNameValue"
        :value="JSON.stringify(activeMultiNameValue)"
      >
      
      <input
        v-if="
          multiNameValue &&
          Object.values(multiNameValue).some(value => value?.length > 0
          && props.charsWeight
          )
        "
        type="hidden"
        id="multiNameValue-totalChars"
        name="multiNameValue-totalChars"
        :value="totalChars"
      >

    
  </div>
</template>

<script setup lang="ts">
const runtimeConfig = useRuntimeConfig();
import { ref, computed, onMounted, watch, nextTick } from 'vue';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/splide.min.css';
import AttributeDescription from "~/components/Product/SingleProduct/Layouts/AttributeDescription.vue";
import NameNecklaceForm from "~/components/Product/SingleProduct/Layouts/NameNecklace.vue";
import Meaning from "~/components/Product/SingleProduct/Guide/Meaning.vue"
const emit = defineEmits(['updatePriceCustomise', 'update-gallery-image', 'update-thumbnail-image', 'update-button-active','update-sku' , 'update-engraving-price']);
const baseUrl = runtimeConfig.public.BASE_URL;
const { $ajax } = useNuxtApp();
type NameNecklace = {
  status?: string;
  afterAttribute?: string;
  idHide?: string | Record<string, string>;
  maxlength?: string;
  symbol?:string
  totalChars?:string
};
interface CharactersWeight {
  [materialId: string]: {
    [characterLength: string]: number
  }
}

interface CalculatedPrice {
  regular_price: number | string
  sale_price: number | string
  short_term_price: number | string
}

const multiNameValue = ref<Record<string, string>>({})
const ids = ref('');
const totalChars = ref('0');

const syncMultiName = (index: number | string, value: string) => {
  const key = String(index)

  if (value) {
    multiNameValue.value[key] = value
  } else {
    delete multiNameValue.value[key]
  }

  const enteredNameCount = Object.values(activeMultiNameValue.value)
    .filter(value => value?.trim()).length;
  if (enteredNameCount < currentCharmCount.value || enteredNameCount === 0) {
    emit('update-button-active', false);
  }
}

const updateMultiName = async (index: number | string, value: string) => {
  syncMultiName(index, value)

  if (!isChoosed.value) {
    if (hasLoadedVariation.value) {
      updateSelectedVariationAndPrice(
        props.multiCustomiseNameNecklace?.status || '',
        props.charsWeight,
        activeMultiNameValue.value
      );
    } else {
      await onOptionClickCustomise(
        mutableSelectedOptions.value['number-of-namenecklace'] || '',
        'number-of-namenecklace',
        'Number Of NameNecklace'
      );
    }
  }

  const enteredNameCount = Object.values(activeMultiNameValue.value)
    .filter(value => value?.trim()).length;
  if (enteredNameCount < currentCharmCount.value || enteredNameCount === 0) {
    emit('update-button-active', false);
  }
}

const props = defineProps<{
  idsFirst: string;
  slug: string;
  priceInfo:[];
  data: any;
  productId: number;
  customiseNameNecklace: NameNecklace;
  multiCustomiseNameNecklace: NameNecklace;
  customiseBackNameNecklace: NameNecklace;
  customiseFontVisualNameNecklace: NameNecklace;
  charsWeight: CharactersWeight,
  titleAtributeP:any;
  materialPriceData: any;
  materialMultiplierData: any;
  saleDate: any;
  checkPixiu: boolean;
  isEngraving: boolean;
  nameCharmSelect: {
    label: string;
    options: { att_id: number;value: number; label: string; title_option: string }[];
  };
  checkChina: string;
}>();

//console.log('---- props222: ',props)
const nameNecklace = computed<NameNecklace>(() => {
  if (props.multiCustomiseNameNecklace?.status === 'yes') {
    return props.multiCustomiseNameNecklace;
  }
  return props.customiseNameNecklace || {};
});
//const selectedPrice = ref(0);
const selectedPrice = ref<{
  regular_price: string | number;
  sale_price: string | number;
  short_term_price: string | number;
}>({ regular_price: 0, sale_price: 0, short_term_price: 0 });


const selectedGallery = ref('');
const selectedThumbnail = ref('');
const isButtonActive = ref(true);
const expandedGemstones = ref<Record<string, boolean>>({});
const mutableSelectedOptions = ref<Record<string, string>>({});
const isCloseButtonVisible = ref(false);
const chooseGemstone = ref('yes');
const isMobile = ref(typeof window !== 'undefined' ? window.innerWidth <= 768 : false);
const isSplideEnabled = ref(false);
const fontSelected = ref('');
const colorSelected = ref('');
let resizeTimeout: NodeJS.Timeout | null = null;

const showCustomSelect = ref(false);
const currentCharmCount = ref(0);
watch(
  mutableSelectedOptions,
  (newValue) => {
    ids.value = newValue
      ? Object.values(newValue).join(',')
      : '';
  },
  { deep: true }
);


const toggleCustomDropdown = () => {
  showCustomSelect.value = !showCustomSelect.value;
};
const selectCharmOption = (value: number,att_id: string) => {
  currentCharmCount.value = value;
  showCustomSelect.value = false;
  mutableSelectedOptions.value['number-of-namenecklace'] = att_id;
  console.log('--- number-of-namenecklace: ',mutableSelectedOptions.value);

  const nameCount = currentCharmCount.value;
  const enteredNameCount = Object.values(multiNameValue.value)
    .filter(value => value?.trim())
    .length;

    console.log(nameCount);
    console.log(enteredNameCount);
    

  if (enteredNameCount > 0 && nameCount <= enteredNameCount) {
  console.log('--- 111111');
  onOptionClickCustomise(
      att_id as string,
      'number-of-namenecklace',
      'Number Of NameNecklace'
    );
  } else {
  console.log('--- 22222');
   isButtonActive.value = false;
  onOptionClickCustomise(
      att_id as string,
      'number-of-namenecklace',
      'Number Of NameNecklace'
    );
    //emit('update-button-active', false);
  }
  
};

// const selectCharmOption = (value: number,att_id: string) => {
//   currentCharmCount.value = value;
//   showCustomSelect.value = false;
//   mutableSelectedOptions.value['number-of-namenecklace'] = att_id;
//   //console.log('--- number-of-namenecklace: ',mutableSelectedOptions.value);

//   const nameCount = currentCharmCount.value;
//   const enteredNameCount = Object.values(multiNameValue.value)
//     .filter(value => value?.trim())
//     .length;

//     //console.log(nameCount);
//     //console.log(enteredNameCount);

//   if (nameCount <= enteredNameCount) {
//     // Just update price, don't call onOptionClickCustomise as it will change activeAttributeGroup
//     const isMultiNecklace = props.multiCustomiseNameNecklace?.status || '';
//     updateSelectedVariationAndPrice(isMultiNecklace, props.charsWeight, activeMultiNameValue.value);
//     emit('update-button-active', true);
//   } else {
//     emit('update-button-active', false);
//   }
// };

// Initials related refs
const initialsCount = ref(0);
const initialsValues = ref<Record<number, string>>({});
const showInitialsDropdown = ref<Record<number, boolean>>({});
const initialsLabel = ref(''); // e.g., "letter" or "letters"
const selectedInitialsItem = ref<any>(null); // Store the selected item to access title_option

const alphabetList = computed(() => {
  return 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
});

const getInitialLabel = (index: number): string => {
  // Determine the suffix (st, nd, rd, th)
  let suffix = 'th';
  if (index === 1) {
    suffix = 'st';
  } else if (index === 2) {
    suffix = 'nd';
  } else if (index === 3) {
    suffix = 'rd';
  }
  
  return `${index}${suffix} initial`;
};

const toggleInitialsDropdown = (index: number) => {
  const isOpening = !showInitialsDropdown.value[index];

  // Keep only one initials menu open to prevent overlapping dropdowns.
  showInitialsDropdown.value = isOpening ? { [index]: true } : {};
};

const selectInitialLetter = (index: number, letter: string) => {
  initialsValues.value[index] = letter;
  showInitialsDropdown.value = {};
};

// Close dropdown when clicking outside
const handleDocumentClick = (event: MouseEvent) => {
  const target = event.target as HTMLElement;
  const selectWrapper = target.closest('.select-wrapper');
  const initialSelectWrapper = target.closest('.initial-select-wrapper');
  
  if (!selectWrapper) {
    showCustomSelect.value = false;
  }
  
  if (!initialSelectWrapper) {
    // Close all initials dropdowns
    Object.keys(showInitialsDropdown.value).forEach(key => {
      showInitialsDropdown.value[parseInt(key)] = false;
    });
  }
};
const activePreview = ref('no');
//const priceData = ref({});

const priceData = ref({
  gemstone_price: 0,
  topup: 0,
  material_data: { material_rate: 0, weight: 0 },
  workmanship: { regular: '', sale: '', short_term: '' }
});
const termIDs = ref('');
const topupOption = ref({});




 const userStore = useUserStore();
 const { $file } = useNuxtApp();


const activeGemstone = ref(0)
const activeAttributeGroup = ref('')
const isChoosed = ref(false);
const hasLoadedVariation = ref(false);
let variationRequestId = 0;

const toggleAttributeGroup2 = (slugKey: string) => {
  const currentItem = document.querySelector(`.gemstone-item-box [data-att="${slugKey}"]`)?.closest('.gemstone-item-box')
  
  // Remove active class from all items
  document.querySelectorAll('.gemstone-item-box').forEach(item => {
    item.classList.remove('active')
  })

  // Add active class to current item
  if (currentItem) {
    currentItem.classList.add('active')
    activeAttributeGroup.value = slugKey
  }
}

const getSelectedAttributeName = (groupKey: string) => {


  const selectedId = mutableSelectedOptions.value[groupKey];
  
  if (!selectedId) return '';

  const attribute = productAttributes.value[groupKey];

  


  // For regular items
  if (attribute.items && Object.keys(attribute.items).length > 0) {

    const selectedItem = Object.values(attribute.items).find((item: any) =>
      item.slug.toString() === selectedId
    )
    return selectedItem ? selectedItem.name : '';
  }

  // For gemstone items
  if (attribute.gemstone_items) {
    for (const gemstoneGroup of Object.values(attribute.gemstone_items)) {
      const selectedItem = Object.values(gemstoneGroup).find((item: any) =>
        item.slug.toString() === selectedId
      );
      if (selectedItem) {
        return selectedItem?.name;
      }
    }
  }
  return '';
};


// const productAttributes = computed(() => {
//   return props.data?.productAttributes || {};
// });

type NameCharmOption = {
  att_id: string;
  value: number;
  label: string;
  title_option: string;
};

const nameCharmSelect = ref<{ label: string; options: NameCharmOption[] }>({
  label: 'Select number of Name Charms (1-4):',
  options: []
});

const selectedNameCharmOption = computed(() =>
  nameCharmSelect.value.options.find(option => option.value === currentCharmCount.value)
);

const inscriptionTitles = computed(() => {
  const titles = props.titleAtributeP?.['number-of-namenecklace'] || {};

  return Object.entries(titles)
    .sort(([firstId], [secondId]) => Number(firstId) - Number(secondId))
    .map(([, title]) => String(title).trim())
    .filter(Boolean);
});

const getNameCharmTitle = (index: number) =>
  inscriptionTitles.value[index - 1] || `Name Charm ${index}`;

const productAttributes = computed(() => {
  const dataAttributes = props.data?.productAttributes || {};

  const numberOfNecklace =
    dataAttributes['number-of-namenecklace'];

   

  const titleAtributeData =
    props?.titleAtributeP || {};
     //console.log('---- props titleAtribute: ',props?.titleAtributeP)

  const titleNumberOfNameNecla =
    titleAtributeData['number-of-namenecklace'] || {};
    //console.log('-- titleNumberOfNameNecla',titleAtributeData,titleNumberOfNameNecla);

  if (numberOfNecklace?.items) {
    const options = Object.values(numberOfNecklace.items)
        .map((item: any) => {
          const match = item.slug?.match(/^(\d+)-/);
          const value = match ? Number(match[1]) : null;

          if (!value) {
            return null;
          }

          // Lấy title theo item.id
          const titleOption =
            titleNumberOfNameNecla[String(item.id)] ?? '';

          return {
            att_id: item.id.toString(),
            value,
            label: item.name,
            title_option: titleOption
          };
        })
        .filter((option): option is NameCharmOption => option !== null)
        .sort((first, second) => first.value - second.value);

    const firstValue = options[0]?.value;
    const lastValue = options[options.length - 1]?.value;
    const rangeItem = firstValue === lastValue
      ? String(firstValue || '')
      : `${firstValue}-${lastValue}`;

    nameCharmSelect.value = {
      label: `Select number of Name Charms (${rangeItem}):`,
      options
    };

    // Options need not begin at 1 (for example, `2-name-charms`).
    // Use the value parsed from the first available slug as the default.
    if (!selectedNameCharmOption.value && firstValue) {
      currentCharmCount.value = firstValue;
    }
  }

  return dataAttributes;
});

const matchesHiddenAttribute = (idHide: NameNecklace['idHide'], key: string) => {
  if (typeof idHide === 'string') return idHide === key;
  return Object.values(idHide || {}).includes(key);
};

const isHiddenGroup = (key: string) => {
  if (!key || key === 'number-of-namenecklace') return true;
  if (nameNecklace.value?.status === 'yes' && matchesHiddenAttribute(nameNecklace.value?.idHide, key)) return true;
  if (props.customiseNameNecklace?.status === 'yes' && matchesHiddenAttribute(props.customiseNameNecklace?.idHide, key)) return true;
  if (props.multiCustomiseNameNecklace?.status === 'yes' && matchesHiddenAttribute(props.multiCustomiseNameNecklace?.idHide, key)) return true;
  return false;
};

const getFirstVisibleGroupKey = () => {
  const keys = Object.keys(productAttributes.value || {});
  return keys.find(key => !isHiddenGroup(key)) || '';
};

watch(
  [
    () => productAttributes.value,
    () => nameNecklace.value?.idHide,
    () => nameNecklace.value?.status,
    () => props.customiseNameNecklace,
    () => props.multiCustomiseNameNecklace
  ],
  () => {
    const firstKey = getFirstVisibleGroupKey();
    if (firstKey && (!activeAttributeGroup.value || isHiddenGroup(activeAttributeGroup.value))) {
      activeAttributeGroup.value = firstKey;
    }
  },
  { immediate: true, deep: true }
);

const activeMultiNameValue = computed(() => {
  const result: Record<string, string> = {};

  for (let i = 1; i <= currentCharmCount.value; i++) {
    const value = multiNameValue.value[i];

    if (value) {
      result[String(i)] = value;
    }
  }

  return result;
});




const idsFirst = computed(() => props.idsFirst.split(',').map(id => id.trim()));

const gemstoneItems = computed(() => {
  return productAttributes.value?.gemstone?.gemstone_items || {};
});

const hasNoStone = computed(() => {
  return productAttributes.value?.gemstone?.has_no_stone || 'no';
});
// Define as a regular function instead of computed
const isGemstoneNone = (gemstoneAttr: any): boolean => {
  // Early return if hasNoStone is not 'yes'
  if (hasNoStone.value !== 'yes') return false;

  // Check if gemstoneAttr exists and has items
  if (!gemstoneAttr || !gemstoneAttr[0]) return false;

  // Return true only if it's a None Gemstone
  return gemstoneAttr[0].slug === 'none';
};


function updateSelectedVariationAndPrice(isMultiNecklace:string,charsWeight:CharactersWeight,multiNameValue:any) {
  const currentPriceData = {
    ...priceData.value,
    material_data: {
      ...priceData.value.material_data,
      material_rate: mutableSelectedOptions.value['material'] || priceData.value.material_data?.material_rate
    }
  };
    let calculatedPrice: CalculatedPrice = {
    regular_price: 0,
    sale_price: 0,
    short_term_price: 0
  }
  console.log('--- isMultiNecklace: ',isMultiNecklace);
  //emit('updatePriceCustomise', priceData.value);
  if (isMultiNecklace === 'yes') {
   calculatedPrice = calculatorPriceCustomiseMultiNameNecklace(
      currentPriceData,
      termIDs.value,
      topupOption.value,
      props.materialPriceData,
      props.materialMultiplierData,
      charsWeight,
      multiNameValue
    ) ?? calculatedPrice;
  } else {
     calculatedPrice = calculatorPriceCustomise2(
       currentPriceData,
       termIDs.value,
       topupOption.value,
       props.materialPriceData,
       props.materialMultiplierData
     );
  }
   
   const finalPriceData = {
      ...calculatedPrice,
      short_term_dates: props.saleDate?.short_term_dates || {},
      sale_price_dates: props.saleDate?.sale_price_dates || {}
    };
    //selectedPrice.value = response.prices;
    console.log('-------- selectedThumbnail: ',selectedThumbnail.value);
    selectedPrice.value = calculatedPrice;
  
  console.log('--- selectedGallery: ',selectedGallery.value)
  if (selectedGallery.value && selectedGallery.value != '') {
    emit('update-gallery-image', selectedGallery.value);
  }
  
  console.log('--- 2')
  if (selectedThumbnail.value && selectedThumbnail.value != '') {
    emit('update-thumbnail-image', selectedThumbnail.value);
  }
  
  
  console.log('--- isMultiNecklace: ',isMultiNecklace)
  if (isMultiNecklace === 'yes') {
  const nameCount = currentCharmCount.value;
  const enteredNameCount = Object.values(
    multiNameValue as Record<string, string>
  ).filter(value => value?.trim()).length;
  emit('updatePriceCustomise', finalPriceData); 
  if (enteredNameCount === 0 || (nameCount > enteredNameCount)) {
    emit('update-button-active', false);
  } else {
  emit('update-button-active', isButtonActive.value);
  
  }

  console.log('--- nameCount:', nameCount, enteredNameCount);
} else {
emit('update-button-active', isButtonActive.value);
emit('updatePriceCustomise', finalPriceData);
 
}

  emit('update-engraving-price', finalPriceData);

}


function resetSelections() {
  variationRequestId++;
  hasLoadedVariation.value = false;
  isChoosed.value = false;
  mutableSelectedOptions.value = {};
  selectedPrice.value = 0;
  selectedGallery.value = '';
  selectedThumbnail.value = '';
  isButtonActive.value = false;
  
  // Reset initials related values
  initialsCount.value = 0;
  initialsLabel.value = '';
  initialsValues.value = {};
  showInitialsDropdown.value = {};
  selectedInitialsItem.value = null;

  // Add any additional reset logic here
}

// const toggleGemstoneVariations = (gemstoneKey: string,groupKey) => {
//   activeGemstone.value = activeGemstone.value === gemstoneKey ? '' : gemstoneKey
// }
// In setup or data
const activeGemstones = ref({})

const toggleGemstoneVariations = (gemstoneKey: string, groupKey: string) => {
    activeGemstones.value[groupKey] = activeGemstones.value[groupKey] === gemstoneKey ? '' : gemstoneKey
}



const isExpandedGemstone = (gemstoneKey: string) => {
  return expandedGemstones.value[gemstoneKey] || false;
};

const isSelected = (id: string, groupKey: string) => {

  //console.log('--- mutableSelectedOptions:',mutableSelectedOptions)
  
  const selectedId = mutableSelectedOptions.value[groupKey];
  if (selectedId) {
    
    return selectedId === id;
  }
  return false;
  
};

const showAttributesDescription = (groupKey: string) => {
  const allDescriptions = document.querySelectorAll('.attrs-description');
  allDescriptions.forEach((desc: Element) => {
    desc.classList.remove('active');
  });

  const targetDescription = document.querySelector(`.attrs-description[data-key="${groupKey}"]`);
  if (targetDescription) {
    targetDescription.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
};


function syncSelectedOptions() {
  mutableSelectedOptions.value = {};

  Object.entries(productAttributes.value).forEach(([groupKey, attributeGroup]: [string, any]) => {
    // For regular items
    if (attributeGroup.items && Object.keys(attributeGroup.items).length > 0) {
      Object.values(attributeGroup.items).forEach((item: any) => {
        if (idsFirst.value.includes(item.id.toString())) {
          mutableSelectedOptions.value[groupKey] = item.id.toString();
          if (groupKey === 'number-of-namenecklace') {
            const match = item.slug?.match(/^(\d+)-/);
            const charmCount = match ? Number(match[1]) : 0;

            if (charmCount) {
              currentCharmCount.value = charmCount;
            }
          }
          if (groupKey === 'font') {
          //colorSelected
            fontSelected.value = item.value;
          }
          if (groupKey === 'color-finish') {
          //colorSelected
            colorSelected.value = item.value;
          }
          // Handle initials - set count and label when syncing
          if (groupKey === 'initials') {
            // Store the selected item
            selectedInitialsItem.value = item;
            
            const match = item.name.match(/^(\d+)\s+(.+)$/);
            if (match) {
              const count = parseInt(match[1], 10);
              
              // Preserve existing values for indices that are still valid
              const newInitialsValues: Record<number, string> = {};
              for (let i = 1; i <= count; i++) {
                newInitialsValues[i] = initialsValues.value[i] || '';
              }
              
              initialsCount.value = count;
              initialsValues.value = newInitialsValues;
              showInitialsDropdown.value = {};
            }
          }
        }
      });
    }

    // For gemstone items
    if (attributeGroup.gemstone_items) {
      Object.values(attributeGroup.gemstone_items).forEach((gemstoneGroup: any) => {
        Object.values(gemstoneGroup).forEach((item: any) => {
          if (idsFirst.value.includes(item.id.toString())) {
            mutableSelectedOptions.value[groupKey] = item.id.toString();
          }
        });
      });
    }
  });

//   priceData = ref({
//   gemstone_price: 0,
//   topup: 0,
//   material_data: { material_rate: 0, weight: 0 },
//   workmanship: { regular: '', sale: '', short_term: '' }
// });

priceData.value.material_data.material_rate = mutableSelectedOptions.value['material'] || '';

  console.log('--- mutableSelectedOptions: ',fontSelected.value,mutableSelectedOptions.value,productAttributes.value);
  activePreview.value = 'yes';
  //console.log('-- activePreview: ',activePreview.value)

}

const route = useRoute();

onMounted(async () => {
  try {
    const queryParams = route.query;
    const hasParams = Object.keys(queryParams).length > 0;
    if (hasParams && ('gemstone' in queryParams || 'color-finish' in queryParams)) {
      const atts = props.data?.productAttributes;

          await nextTick();
          setTimeout(async () => {

              for (const [paramName, paramValue] of Object.entries(queryParams)) {
                let attribute = productAttributes.value[paramName];
                let attributeName = attribute?.name || "";
                let attributeId = attribute?.id || "";
                let attributeSlug = paramValue
                let groupKey = paramName;
           // if (activeGemstones.value && activeGemstones.value[groupKey] !== undefined) {
              Object.entries(atts).forEach(([groupKey, item]: [string, any]) => {
                if (item.type === 'gemstone') {
                
                  for (const [groupId, stones] of Object.entries(item.gemstone_items)) {
                    const stone = Object.values(stones).find(stone => stone.slug === attributeSlug)
                    if (stone) {
                      attributeId = stone.id.toString()
                      activeGemstones.value[groupKey] = groupId
                      break
                    }

                  }
                } else {
                  
                   for (const [groupId, colors] of Object.entries(item.items)) {
                      //const stonesArray = Object.values(colors)
                      const stone = colors.slug === paramValue

                      if (stone) {
                        attributeId = colors.id.toString()
                        break
                      }
                    }
                }
              });


             // }
                await onOptionClickCustomise(attributeId as string, groupKey, attributeName);

              }
          }, 1000);

    }
  } catch (error) {
    console.error('Error in onMounted processing:', error);
  }

 // console.log('---onmounted props.multiCustomiseNameNecklace?.status,',props.multiCustomiseNameNecklace?.status)
if (props.multiCustomiseNameNecklace?.status === 'yes') {
    const nameCount = Object.values(multiNameValue.value || {})
      .filter(value => value?.trim())
      .length;

    console.log('-- nameCount',nameCount);

    if (nameCount === 0) {
    //console.log('--- false')
      emit('update-button-active', false);
    }
  }
});

const onOptionClickCustomise = async (attributeSlug: string, groupKey: string,attributeName?: string) => {
  const requestId = ++variationRequestId;

  //console.log('-- attributeSlug: ',attributeSlug,groupKey,attributeName);
  const attribute = productAttributes.value[groupKey];
  if (groupKey === 'font') {
    //console.log('-- attribute: ',attribute);
    if (attribute?.items && Object.keys(attribute?.items).length > 0) {
        const items = Object.values(attribute.items);
        const item = items.find((item: any) => item.id.toString() === attributeSlug);
        fontSelected.value =  item ? item?.value : '';
      }
  }

  if (groupKey === 'color-finish') {
   // console.log('-- attribute: ',attribute);
    if (attribute?.items && Object.keys(attribute?.items).length > 0) {
        const items = Object.values(attribute.items);
        const item = items.find((item: any) => item.id.toString() === attributeSlug);
        colorSelected.value =  item ? item?.value : '';
      }
  }

  

   isChoosed.value = true;
   let attrPush = '';
// push url
  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  if (searchParams.has(groupKey)) {
   // let slug = '';
    
    //console.log('-- attribute param: ',attribute);
    if (attribute.type==='gemstone' && attribute?.gemstone_items && typeof attribute?.gemstone_items === 'object') {

        Object.values(attribute?.gemstone_items).some((gemstoneAttr: any) => {
          if (gemstoneAttr && Object.keys(gemstoneAttr).length > 0) {
            const items = Object.values(gemstoneAttr);
            const foundItem = items.find((item: any) => item.id.toString() === attributeSlug);
            if (foundItem) {
              attrPush = foundItem.slug;
            }
          }
          
        });

    } else {
      if (attribute?.items && Object.keys(attribute?.items).length > 0) {
        const items = Object.values(attribute.items);
        const item = items.find((item: any) => item.id.toString() === attributeSlug);
        attrPush =  item ? [item?.slug] : [];
      }

    }
    //console.log('44444-----attribute',attribute);
    searchParams.set(groupKey, attrPush);
  } 
  window.history.replaceState({}, '', currentUrl.toString());
  //============ Update the selected option
  mutableSelectedOptions.value[groupKey] = attributeSlug;

  // Handle initials count when selecting initials
  if (groupKey === 'initials') {
    const attribute = productAttributes.value[groupKey];
    if (attribute?.items && Object.keys(attribute?.items).length > 0) {
      const items = Object.values(attribute.items);
      const selectedItem = items.find((item: any) => item.id.toString() === attributeSlug);
      if (selectedItem) {
        // Store the selected item to access title_option or name
        selectedInitialsItem.value = selectedItem;
        
        // Extract number and text from name like "1 letter", "2 letters", "3 letters"
        const match = selectedItem.name.match(/^(\d+)\s+(.+)$/);
        if (match) {
          const count = parseInt(match[1], 10);
          
          // Preserve existing values for indices that are still valid
          const newInitialsValues: Record<number, string> = {};
          for (let i = 1; i <= count; i++) {
            newInitialsValues[i] = initialsValues.value[i] || '';
          }
          
          initialsCount.value = count;
          initialsValues.value = newInitialsValues;
          
          // Reset dropdown state
          showInitialsDropdown.value = {};
        }
      }
    }
  }

  const attributeSpan = document.querySelector(`.attribute_selected_name[data-attribute-key="${attributeName}"]`);
  //console.log('--- 11 attributeSpan:',attributeSpan)
  if (attributeSpan){
    attributeSpan.classList.add('selected');
  }
  // Set active attribute group directly without clearing to avoid resize event interference
  // Only update active group if it is a visible accordion group
  if (
    groupKey !== 'number-of-namenecklace' &&
    !(nameNecklace.value?.status === 'yes' && matchesHiddenAttribute(nameNecklace.value?.idHide, groupKey))
  ) {
    activeAttributeGroup.value = String(groupKey);
  }

  

  const activeAttributes = Object.entries(mutableSelectedOptions.value)
    .flatMap(([key, value]) => {

    //console.log('---- key value',key, value);
      const attribute = productAttributes.value[key];
     
      if (attribute?.items && Object.keys(attribute?.items).length > 0) {
        const items = Object.values(attribute.items);
        //console.log('--- items',items);
        const item = items.find((item: any) => item.id.toString() === String(value));
        //console.log('--- item: ',item);
        return item ? [item?.id] : [];
      }
      if (attribute?.gemstone_items && typeof attribute?.gemstone_items === 'object') {
        let foundItem: any = null;
        Object.values(attribute?.gemstone_items).some((gemstoneAttr: any) => {
          if (gemstoneAttr && Object.keys(gemstoneAttr).length > 0) {
            const items = Object.values(gemstoneAttr);
            foundItem = items.find((item: any) => item.id.toString() === value);
            return !!foundItem;
          }
          return false;
        });

        return foundItem ? [foundItem.id] : [];
      }


      return [];
    })
    .filter(Boolean);

    //console.log('--- activeAttributes: ',activeAttributes,mutableSelectedOptions.value)

  const slugVariation = activeAttributes.join(',').toLowerCase().replace(/\s+/g, '-');
  //console.log(slugVariation);
  //https://uatstaging.skjewellery.com/data/customise/661415/2,62,4,43
 //const slug = `wp-json/customise/v1/variation?product_id=${props?.productId}&attr_term_ids=${slugVariation}`;
 //const slug = `wp-json/customise/v1/variation?product_id=${props?.productId}&attr_term_ids=${slugVariation}`;

 //======================= get data variaiton customise ====================================================

 const slug = `${baseUrl}data/customise/${props?.productId}/${slugVariation}`;
 hasLoadedVariation.value = false;
 //console.log(slug);
  try {
  
    const response = await $ajax.get( `${slug}`, {
            cache: "no-cache"
        });
    if (requestId !== variationRequestId) return;
  

    if (response) {
     //console.log('---- selectedPrice.value: ',response);
     //  selectedPrice.value = response.prices;
      priceData.value = response.data?.price_data?.meta_value || '';
       hasLoadedVariation.value = Boolean(priceData.value);
       termIDs.value = response.data?.term_ids || slugVariation;
       topupOption.value = response.data?.options?._topup || {};
       selectedGallery.value = response.data?.media;
       selectedThumbnail.value = response.data?.thumbnail;
       isButtonActive.value = true;
       //console.log('---- select variation customiser ',response, priceData.value);
       emit('update-sku', response.data.sku.meta_value);

      // console.log('--- multiNameValue',activeMultiNameValue.value);
       const isMultiNecklace = props.multiCustomiseNameNecklace?.status || '';
       updateSelectedVariationAndPrice(isMultiNecklace,props.charsWeight,activeMultiNameValue.value);
      //  if (props.multiCustomiseNameNecklace?.status === 'yes') {
      //   updateSelectedVariationAndPriceMultiNecklace(props.charsWeight);
      //  } else {
        
      //  }

      
     
    } else {
      //emit('update-button-active', false);
    }
  } catch (error) {
    if (requestId !== variationRequestId) return;
    isButtonActive.value = false;
    console.error('Error updating customise variation price:', error);
    emit('update-button-active', false);
    
  }
  finally {
    if (requestId === variationRequestId) {
        isChoosed.value = false;
    }
    }

  await nextTick();
};
const toggleAttributeGroup = (groupKey: string | number) => {
  if (isMobile.value) {
    const key = String(groupKey);
    activeAttributeGroup.value = activeAttributeGroup.value === key ? '' : key;
  }
}

const isActiveAttributeGroup = (key: string | number) => {
  return isMobile.value && activeAttributeGroup.value === String(key);
}

const handleResize = () => {
  isSplideEnabled.value = window.innerWidth < 769;

  // Debounce resize handler to prevent rapid updates from keyboard appearance
  if (resizeTimeout) {
    clearTimeout(resizeTimeout);
  }
  
  resizeTimeout = setTimeout(() => {
    isMobile.value = window.innerWidth <= 768;
    if (!activeAttributeGroup.value || isHiddenGroup(activeAttributeGroup.value)) {
      const firstKey = getFirstVisibleGroupKey();
      if (firstKey) {
        activeAttributeGroup.value = firstKey;
      }
    }
    resizeTimeout = null;
  }, 300);
};

onMounted(() => {

  syncSelectedOptions();

  const atts = props.data?.productAttributes;
  //console.log('--- atts: ',atts)

  if (atts) {
    Object.entries(atts).forEach(([groupKey, item]: [string, any]) => {
      if (item.type === 'gemstone') {
        const firstKey = Object.keys(item.gemstone_items)[0];
        activeGemstones.value[groupKey] = firstKey;
      }
    });
  }

  // active first visible attribute
  isMobile.value = window.innerWidth <= 768;
  isSplideEnabled.value = window.innerWidth < 769;
  const firstKey = getFirstVisibleGroupKey();
  if (firstKey && (!activeAttributeGroup.value || isHiddenGroup(activeAttributeGroup.value))) {
    activeAttributeGroup.value = firstKey;
  }

  window.addEventListener('resize', handleResize);

  // Add click outside listener for custom dropdown
  document.addEventListener('click', handleDocumentClick);
  const firstCharsWeight = Object.values(props.charsWeight || {})[0];
  const maxLengths = Object.keys(firstCharsWeight || {})
    .map(range => Number(range.split('-')[1]))
    .filter(Number.isFinite);
  totalChars.value = String(Math.max(0, ...maxLengths));
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
  document.removeEventListener('click', handleDocumentClick);
  if (resizeTimeout) {
    clearTimeout(resizeTimeout);
  }
});

watch(() => props.idsFirst, syncSelectedOptions);

const isGridView = ref<Record<string, boolean>>({});

const splideOptions = {
  arrows: false,
  pagination: false,
  autoWidth: true,
  drag: "free",
  gap: "12px",
  mediaQuery: "max",
  arrowPath: "",
};


const displayGrid = (gemstoneKey: string) => {
  isGridView.value[gemstoneKey] = true;
};

const displayList = (gemstoneKey: string) => {
  isGridView.value[gemstoneKey] = false;
};

const chooseNoneStone = (value: string): void => {
  chooseGemstone.value = value;
  nextTick(() => {
    const gemstoneBoxes = document.querySelectorAll('.gemstone-item-box');

    if (value === 'no') {
      // Handle no stone selection
      const firstNoneStone = document.querySelector('.gemstone_none li:first-child') as HTMLElement;
      firstNoneStone?.click();

      // Hide boxes and remove active class
      gemstoneBoxes.forEach(box => {
        (box as HTMLElement).style.display = 'none';
        box.classList.remove('active');
      });
    } else {
      // Handle regular stone selection
      const firstGemstone = document.querySelector('.gemstone-wrapper li:first-child') as HTMLElement;
      firstGemstone?.click();

      // Show boxes
      gemstoneBoxes.forEach(box => {
        (box as HTMLElement).style.display = 'block';
      });
    }
  });
}


</script>
<style lang="scss">
  @import "@/assets/scss/components/product/_variable.scss";
  @import "@/assets/scss/components/product/_variable_customise.scss";

  .dropdown-arrow {
    &.dropdown-arrow-open {
      transform: rotate(180deg);
    }
  }

</style>
